import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary.js"; // Import the ErrorBoundary component
import "./index.css";

// Check if the root element exists before rendering
const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
} else {
  console.error("Root element not found. Ensure your HTML has a <div id='root'></div>.");
  console.log("ErrorBoundary imported:", ErrorBoundary);
}
